import { parse } from 'tldts';

import { hasText } from '@/utils/strings';

export interface DomainValidationResult {
  isValid: boolean;
  cleanValue: string | undefined;
}

export function validateDomain(input: string | null | undefined): DomainValidationResult {
  const invalid: DomainValidationResult = { isValid: false, cleanValue: undefined };

  if (!hasText(input)) {
    return invalid;
  }

  const result = parse(input.trim(), { extractHostname: true });

  // isIp covers both IPv4 and IPv6; domain/publicSuffix are null for unrecognized hosts
  if (result.isIp !== false || result.domain === null || result.publicSuffix === null) {
    return invalid;
  }

  // result.domain is already the registrable domain stripped of subdomains/www
  // e.g. "my.sub.example.co.uk" → "example.co.uk"
  return { isValid: true, cleanValue: result.domain };
}
